// @flow
import React from 'react';
import { clamp, isEqual } from 'lodash';
import classNames from 'classnames';
// import { CSSTransition } from 'react-transition-group';
import './ProgressBar.scss';

type Props = {
  show?: boolean,
  // Where the fill starts, in %: a bar that only shows once a load is slow starts with some green
  startAt?: number,
};

type State = {
  percent: number,
  ended: boolean,
  destroyed: boolean,
};

const STEP = 5;
const DURATION = 300; // based on transition-duration in css
const END_DURATION = 300; // based on transition-duration in css

export default class ProgressBar extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    // Mounted with show={false} (kept mounted and toggled), it waits hidden until shown
    const hidden = props.show === false;
    this.state = {
      percent: props.startAt || 0,
      ended: hidden,
      destroyed: hidden,
    };
  }

  componentDidMount() {
    if (this.props.show !== false) this.initializeProgress();
  }

  componentWillReceiveProps(nextProps: Props) {
    if (nextProps.show === true && this.props.show === false) {
      // Shown again while it was still finishing: that finish must not hide it
      clearTimeout(this.finishTimer);
      this.initializeProgress();
      this.setState({ ended: false, percent: nextProps.startAt || 0, destroyed: false });
    }

    if (this.props.show !== false && nextProps.show === false && !this.state.ended) {
      clearInterval(this.interval);
      clearTimeout(this.finishTimer);
      this.setState({ percent: 100 }, () => {
        this.finishTimer = setTimeout(() => this.setState({ ended: true }, () => {
          this.finishTimer = setTimeout(() => this.setState({ percent: 0, destroyed: true }), END_DURATION);
        }), DURATION);
      });
    }
  }

  shouldComponentUpdate(nextProps: Props, nextState: State) {
    return !isEqual(this.props, nextProps) || !isEqual(this.state, nextState);
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
    clearTimeout(this.finishTimer);
  }

  render() {
    const { ended, percent, destroyed } = this.state;

    if (destroyed) {
      return null;
    }

    return (
      <div className={classNames('progressBarWrapper', { ended })}>
        <span className="progressBar" style={{ width: `${percent}%` }} />
      </div>
    );
  }
  interval: any = null;

  finishTimer: any = null;

  initializeProgress = () => {
    if (this.interval) {
      clearInterval(this.interval);
    }
    this.interval = setInterval(() => this.setState({ percent: clamp(this.state.percent + STEP, 0, 90) }), 500);
  }
}
